import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { useLocalStorage } from "../utils/LocalStorageHook";
import { Autocomplete, Chip, CircularProgress, Grid, Paper, TextField } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import VendingVisualizer from "./VendingVisualizer";
import CardKPI from "./request/CardKpiBank";
import MaterialsComponent from "./MaterialComponent";
import VolumePrediction from "../components/request/VolumePredictionGraph";
import { AXIOS_INSTANCE, BASE_URL } from "src/App";

interface BankOverviewInput {
  customer_num: string;
  bankedRecommendations?: any;
  bankedReplaced?: any[];
  bankedApplyRecommendation?: any[];
  replaceMaterialSelectorOpts?: any;
  setRecoState?: (state: any, replaced: any) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chip: {
      marginLeft: theme.spacing(1),
    },
    root: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(4),
    },
    header: {
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(1),
    },
    msg:{marginTop:  theme.spacing(4),
    paddingBottom:  theme.spacing(10),
    paddingTop:  theme.spacing(5),
    marginLeft:  theme.spacing(1),
  },
    visualizerPaper: {
      paddingBottom: theme.spacing(2),
    },
    kpi: {
      paddingBottom: theme.spacing(1),
    },
    table: {
      marginTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    paperVolume: {
      padding: theme.spacing(2),
    },
  })
);

export default function BankOverview(props: BankOverviewInput) {
  // console.log(props);
  const [state, setState] = useState<any>({
    recos: props.
    bankedRecommendations,
    replaced: [],
  });
  const [selected, setSelected] = useState<any>();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [wasClicked, setWasClicked] = useState<any[]>([]);

  const classes = useStyles();

  if (state.recos.length < 1) {
    return <CircularProgress />;
  }

  let min_days_cover_predicted = Number.MAX_SAFE_INTEGER;
  let min_days_cover_current = Number.MAX_SAFE_INTEGER;

  let volume_predicted = 0;
  let volume_current = 0;

  let grlc_predicted = 0;
  let grlc_current = 0;

  let rev_predicted = 0;
  let rev_current = 0;
  for (let s of state.recos) {
    let kpis = s.kpis;
    if(kpis){
      if (min_days_cover_predicted > kpis[0].days_cover) {
        min_days_cover_predicted = kpis[0].days_cover;
      }

      if (min_days_cover_current > kpis[1].days_cover) {
        min_days_cover_current = kpis[1].days_cover;
      }

      volume_predicted += kpis[0].eaches;
      volume_current += kpis[1].eaches;

      grlc_predicted += kpis[0].grlc;
      grlc_current += kpis[1].grlc;

      rev_predicted += kpis[0].rev;
      rev_current += kpis[1].rev;
    }
  }

  const kpis = [
    {
      days_cover: min_days_cover_predicted,
      eaches: volume_predicted,
      grlc: grlc_predicted,
      rev: rev_predicted,
      source: "Recommended",
    },
    {
      days_cover: min_days_cover_current,
      eaches: volume_current,
      grlc: grlc_current,
      rev: rev_current,
      source: "Current",
    },
  ];

  const passToTable: any = {
    data: {
      cmap: [],
      mapd: [],
    },
  };

  for (let s of state.recos) {
    if(s.cmap && s.mapd){
      passToTable.data.cmap = [...passToTable.data.cmap, ...s.cmap];
      passToTable.data.mapd = [...passToTable.data.mapd, ...s.mapd];
    }
  }

  let passToGraphCurr: any[] = [];
  let passToGraphAllMats: any[] = [];
  let passToGraphRMats: any[] = [];
  let infoGraphData: any[]=[];
  let column_counts_curr: { [key: string]: number } = {};
  let column_counts_reco: { [key: string]: number } = {};
  if(state.recos) {
    if(state.recos[0].info){
      infoGraphData=state.recos[0].info;
    } else{
      infoGraphData=state.recos[1].info;
    }
   
  }
  for (let s of state.recos) {
    if(s.allMats){
      let curr = s.curr;
      let allMats = s.allMats;
      let rmats = s.rmats;
      //let info = s.info;
      
      for (let c of curr) {
        let found = passToGraphCurr.find((v) => v.material_num === c.material_num);
        if (!column_counts_curr[c.material_num]) {
          column_counts_curr[c.material_num] = 1;
        } else {
          column_counts_curr[c.material_num]++;
        }

        if (!found) {
          passToGraphCurr.push({ ...c });
        }
      }

      for (let a of allMats) {
        let found = passToGraphAllMats.find((v) => v.material_num === a.material_num);

        if (!found) {
          passToGraphAllMats.push({ ...a });
        }
      }

      for (let r of rmats) {
        let found = passToGraphRMats.find((v) => v.material_num === r.material_num);
        if (!column_counts_reco[r.material_num]) {
          column_counts_reco[r.material_num] = 1;
        } else {
          column_counts_reco[r.material_num]++;
        }

        if (!found) {
          passToGraphRMats.push({ ...r });
        }
      }
    }
  }

  for (let pt of passToTable.data.cmap) {
    for (let _c in column_counts_curr) {
      if (pt.material_num === _c) {
        pt.column_count = column_counts_curr[_c];
        break;
      }
    }
  }

  for (let pt of passToTable.data.mapd) {
    for (let _c in column_counts_reco) {
      if (pt.material_num === _c) {
        pt.column_count = column_counts_reco[_c];
        break;
      }
    }
  }

  const highlightClick = (torep: any[], newMat: any, customer_num: string) => {
    let nm = typeof newMat === "string" ? { material_num: newMat } : newMat;

    const attemptLook = async () => {
      for (let _r of state.recos) {
        for (let r of _r.mapd) {
          if (r.material_num === nm.material_num) {
            return r;
          }
        }
      }

      return await AXIOS_INSTANCE({
        method: "POST",
        params: {
          clientId: 100,
          salesOrg: salesOrg,
        },
        data: {
          customerNum: customer_num,
          newFlavors: true,
          maxFlavors: false,
          newMat,
        },
        url: `${BASE_URL}/api/recommendation/search`,
      }).then((v) => v.data);
    };

    attemptLook().then((_found: any) => {
      for (let _torep of torep) {
        state.replaced.push({
          machine: customer_num,
          data: {
            material: {
              ..._found,
            },
            column_num: _torep.column_num,
            modified: true,
          },
        });
      }

      props.setRecoState!(state.recos, state.replaced);
    });
  };

  return (
    <div>
      <div className={classes.kpi}>
        <CardKPI kpis={kpis} />
      </div>
      <Grid container spacing={1}>
        {state.recos.map((r: any, i: number) => (
          <Grid item lg={6}>
             {r.info && (
            <Paper elevation={3}>
              <Typography variant="h6" className={classes.header}>
                {`${r.info.name1} (${r.info.customer_num})`}
              </Typography>
              <Chip
                size="small"
                color="primary"
                className={classes.chip}
                label={`Visited every: ${r.cols.avg_visit_period} day(s).`}
              />
              <Chip
                size="small"
                color="primary"
                className={classes.chip}
                label={`Predicted Cover: ${r.kpis[0].days_cover.toFixed(2)} day(s).`}
              />
              <VendingVisualizer
                key={`reco-${i}`}
                // applyRecommended={
                //   (
                //     props.bankedApplyRecommendation!.find((v: any) => v.machine === r.info.customer_num) || {
                //       state: true,
                //     }
                //   ).state
                // }
                recommended={r.mapd}
                cols={r.cols}
                columns={r.cmap}
                selected={selected}
                salesOrg={salesOrg}
                // replaced={props
                //   .bankedReplaced!.filter((v: any) => v.machine === r.info.customer_num)
                //   .map((v: any) => v.data)}
                onSwap={(to: any, from: any) => {
                  state.replaced = state.replaced.concat([
                    {
                      machine: r.info.customer_num,
                      data: {
                        material: {
                          ...to.material,
                        },
                        column_num: from.column_num,
                        modified: true,
                      },
                    },
                    {
                      machine: r.info.customer_num,
                      data: {
                        material: {
                          ...from.material,
                        },
                        column_num: to.column_num,
                        modified: true,
                      },
                    },
                  ]);

                  props.setRecoState!(state.recos, state.replaced);
                }}
                onDragReplace={(from, to) => {
                  for (let _r = 0; _r < state.recos.length; _r++) {
                    if (_r !== i) continue;
                    let r = state.recos[_r];
                    for (let _inR in r.mapd) {
                      let inR = r.mapd[_inR];

                      if (inR.column_num === to.column_num) {
                        state.replaced.push({
                          machine: r.info.customer_num,
                          data: {
                            material: {
                              ...inR.material,
                            },
                            column_num: from.column_num,
                            modified: true,
                          },
                        });
                        break;
                      }
                    }
                  }

                  props.setRecoState!(state.recos, state.replaced);
                }}
                replacing={wasClicked.filter((v) => v.machine === r.info.customer_num).map((v) => v.data)}
                onSelect={(m) => {
                  let found = wasClicked.find(
                    (v: any) => v.machine === r.info.customer_num && m.column_num === v.data.column_num
                  );

                  if (found) {
                    const out = wasClicked.filter(
                      (v) => v.machine !== r.info.customer_num && v.data.column_num !== m.column_num
                    );

                    setWasClicked([...out]);
                  } else {
                    setWasClicked([
                      ...wasClicked,
                      {
                        data: m,
                        machine: r.info.customer_num,
                      },
                    ]);
                  }
                }}
                onHover={(matnr: string) => setSelected(matnr)}
              />
            </Paper>
            )}
            {!r.info && (
              <Paper elevation={3}>
              <Typography variant="h6" className={classes.header}>
                {`${r.name1} (${r.customer_num})`}
              </Typography>
              
              <Typography variant="h6" className={classes.msg}>
                {`${r.errorMessage}`} </Typography>
            
              </Paper>
              )}
          </Grid>
        ))}
      </Grid>
      <div className={classes.table}>
        {/* <Autocomplete
          id="replace-selected"
         options={props.replaceMaterialSelectorOpts!.sort((a: any, b: any) => a.source.localeCompare(b.source) > 0)}
          getOptionLabel={(option: any) => `${option.data}`}
          groupBy={(option) => option.source}
          onChange={(_, newMat) => {
            const toRepl = wasClicked.map((v: any) => v.data);
            const customerNum = wasClicked[0].machine;
            highlightClick(toRepl, newMat, customerNum);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              let newMat = (event.target as any).value;
              if (!newMat) return;
              let found = props.replaceMaterialSelectorOpts!.find((v: any) => v.data === newMat);
              if (!found) return;

              for (let v of wasClicked) {
                for (let _r = 0; _r < props.bankedRecommendations; _r++) {
                  let r = props.bankedRecommendations[_r];

                  if (_r === v.machine) {
                    for (let col of r.mapd) {
                      if (col.column_num === v.column_num) {
                        col.material = {
                          ...v.material,
                        };

                        break;
                      }
                    }
                  }
                }
              }

              // props.setRecoState!(props.bankedRecommendations);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Replace Material"
              helperText="Click material or press the enter key once selected."
            />
          )}
        /> */}
      </div>
      <div className={classes.table}>
        <Grid container spacing={1}>
          <Grid item lg={6}>
            <MaterialsComponent
              isActive={true}
              customer={""}
              state={passToTable}
              selected={selected}
              onHover={(matnr: string) => setSelected(matnr)}

              /**
               * Fix me
               */
            />
          </Grid>
          <Grid item lg={6}>
            <MaterialsComponent
              isActive={false}
              customer={""}
              showRecommendation={true}
              state={passToTable}
              selected={selected}
              onHover={(matnr: string) => setSelected(matnr)}
            />
          </Grid>
          <Grid item lg={12}>
            <Paper className={classes.paperVolume}>
              <VolumePrediction
                dataI={{
                  curr: passToGraphCurr,
                  rmats: passToGraphRMats,
                  allMats: passToGraphAllMats,
                  info:infoGraphData,
                }}
                swapElement={() => {}}
                toReplace
              />
            </Paper>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
